<template>
<div class="card card-chart">
  <div class="card-header no-padding" :style="style">
    <div :class="['square-box', gradient]">
      <slot name="header"></slot>
    </div>
  </div>
  <div class="card-content">
    <slot name="content"></slot>
  </div>
</div>
</template>

<script>
export default {
  name: 'square-card',
  props: {
    gradient: {
      type: String,
      default: 'gradient-user'
    },
    backgroundImg: {
      type: String
    }
  },
  computed: {
    style: function() {
      if (this.backgroundImg) {
        return {
          background: 'url(' + this.backgroundImg + ')',
          backgroundSize: 'cover',
          backgroundColor: 'darkgrey'
        }
      } else return {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/config.scss';

.card-chart {
  .card-content {
    margin: 0px;
    padding: 20px 17px 8px;
  }

  .title {
    color: $grey;
    margin: 0px;
    padding: 0px;
    line-height: 14px;
    @include normalFontSize();
  }

  .card-footer {
    .stats .material-icons {
      color: $grey;
    }
  }
}

.square-box {
  position: relative;
  overflow: hidden;
  opacity: 0.75;
}
.square-box:before {
  content: '';
  display: block;
  padding-top: 100%;
}
.square-content {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  color: white;
  text-align: center;

  i {
    color: white;
    font-size: 40px;
  }
}

.flex {
  justify-content: space-between;
  align-items: center;
}

.label {
  padding: 0px;
  color: $black;
  font-weight: 700;
  @include biggestFontSize();
}

.card .card-header.no-padding {
  padding: 0px !important;
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/SquareCard.vue